import React from 'react';
import { Field, FieldRenderProps, useForm, FieldProps } from 'react-final-form';
import AutoSave from '../AutoSave';
import SingleSelect, {
  OptionItem,
} from '../../../components/Inputs/SingleSelect';
import { IndicatorStateOptions } from '../../../components/Indicator';

// FIXME making custom props optional until this is resolved:
// https://github.com/final-form/react-final-form/issues/175
type SingleChoiceInputMetaProps = {
  invalid?: boolean;
  error?: string;
  initial?: any;
  disabled?: boolean;
  submitting?: boolean;
  submitFailed?: boolean;
  submitSucceeded?: boolean;
  dirtySinceLastSubmit?: boolean;
  dirty?: boolean;
};

const getIndicatorState = (
  props: SingleChoiceInputMetaProps,
): IndicatorStateOptions => {
  let state: IndicatorStateOptions = 'new';
  if (props.initial) state = 'complete';
  if (props.error || props.invalid) state = 'error';
  if (props.submitting && props.dirtySinceLastSubmit !== props.dirty)
    state = 'loading';
  return state;
};

interface SingleChoiceInputFieldComponentProps
  extends FieldRenderProps<string, HTMLInputElement> {
  text?: string;
  informationText?: string[];
  enabled?: boolean;
  supportingLink?: React.MouseEventHandler;
  handleSubmit?: () => void;
  options?: OptionItem[];
}

const SingleChoiceInputFieldComponent = ({
  input,
  meta,
  handleSubmit,
  enabled,
  ...rest
}: SingleChoiceInputFieldComponentProps) => {
  return (
    <AutoSave
      name={input.name}
      handleSubmit={handleSubmit ? handleSubmit : () => {}}>
      <SingleSelect
        {...input}
        {...meta}
        enabled={enabled}
        // disabled={meta.submitting}
        indicatorState={getIndicatorState(meta)}
        {...rest}
      />
    </AutoSave>
  );
};

export interface SingleChoiceInputFieldProps
  extends FieldProps<string, FieldRenderProps<string>> {
  text?: string;
  informationText?: string[];
  supportingLink?: React.MouseEventHandler;
  options?: OptionItem[];
  enabled?: boolean;
  required?: boolean;
}

const SingleChoiceField = (props: SingleChoiceInputFieldProps) => {
  const form = useForm();
  const required = !(props.enabled === false) && props.required;
  return (
    <Field<string>
      component={SingleChoiceInputFieldComponent}
      handleSubmit={form.submit}
      {...props}
      required={required}
      validate={required ? props.validate : undefined}
    />
  );
};

export default SingleChoiceField;
